import { CButton, CCol, CContainer, CRow, CFormSelect, CFormInput, CFormCheck, CForm } from "@coreui/react";
import { useState, useEffect, useMemo, useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { BusinessPojo } from "../../../services/Business/BusinessPojo/BusinessPojo";
import { SubmitHandler, useForm } from "react-hook-form";
import { Language } from "../../../language/English";
import Notification from "../../../services/Notification/Notification";
import { CountryCode } from "../../../meta/CountryCode";
import Logger from "../../../services/Logger/Logger";
import { useParams } from "react-router";
import { BusinessService } from "../../../services/Business/BusinessService";
import { BusinessNotificationValidation } from "../../../services/Business/BusinessNotificationValidation";
import { DUBAI_COUNTRY_CODE } from "../../../services/Business/BusinessConstant";
import Loader from "../../../components/Layout/Loader";
import { BusinessNotificationPojo } from "../../../services/Business/BusinessPojo/BusinessNotificationPojo";

const BusinessNotificationForm = () => {
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const { businessId } = useParams();
    const businessService = useMemo(() => new BusinessService(), []);
    const [ businessDetails, setBusinessDetails] = useState<BusinessPojo>();
    const notification = useMemo(() => new Notification(), []) ;
    const logger = useMemo(() => new Logger(), []) ;
    const fetchDetails = useCallback( async() : Promise<void> => {
        try{
            if(businessId !== undefined){
                setShowLoader(true);
                const response = await businessService.loadById(parseInt(businessId));
                if(response.isSuccess){
                    setBusinessDetails(response.business);
                } else {
                    notification.error(Language.SOMETHING_IS_WRONG);
                }
                setShowLoader(false);
            } else {
                setBusinessDetails(undefined);
            }
        } catch (e){
            notification.error(Language.SOMETHING_IS_WRONG);
            setShowLoader(false);
            logger.error(e);
        }
    }, [businessId, businessService, logger, notification]);
    
    useEffect(() => {
        fetchDetails();
    }, [businessId, fetchDetails]);

    useEffect(() => {
        const contactDetails = businessDetails?.contactDetails ? JSON.parse(businessDetails.contactDetails) : undefined;

        if(contactDetails){
            contactDetails.map((detail: any) => {
                if(detail?.sendNotificationByWhatsApp){
                    setValue('sendNotificationByWhatsApp', detail?.sendNotificationByWhatsApp || false);
                    setValue('whatsappPhoneCountryCode', detail?.whatsappPhoneCountryCode || DUBAI_COUNTRY_CODE);
                    setValue('whatsappPhoneNumber', detail?.whatsappPhoneNumber || 0);
                }
                if(detail?.sendNotificationByEmail){
                    setValue('sendNotificationByEmail', detail?.sendNotificationByEmail || false);
                    setValue('email', detail?.email || '');
                }
                if(detail?.sendNotificationBySms){
                    setValue('sendNotificationBySms', detail?.sendNotificationBySms || false);
                    setValue('smsPhoneCountryCode', detail?.smsPhoneCountryCode || DUBAI_COUNTRY_CODE);
                    setValue('smsPhoneNumber', detail?.smsPhoneNumber || 0);
                }
            });
        }
    }, [businessDetails]);



    const formValidation = BusinessNotificationValidation();
    const {register, handleSubmit, setValue, formState : {errors}} = useForm<BusinessNotificationPojo>({
        resolver : yupResolver(formValidation)
    });


    const onSubmit: SubmitHandler<BusinessNotificationPojo> = async(data) :Promise<void> => {
        try {
            setShowLoader(true);
            console.log(businessDetails?.businessId);
            if(businessDetails?.businessId){
                data.businessId = businessDetails?.businessId;
                const response = await businessService.updateBusinessNotification(data);
                if(response.isSuccess){
                    notification.success(Language.BUSINESS_SUCCESSFULLY_UPDATED);
                } else {
                    notification.error(Language.BUSINESS_NOT_UPDATED_TECHNICAL_ERROR);
                }
            }
            setShowLoader(false);
        } catch (e){
            notification.error(Language.SOMETHING_IS_WRONG);
            setShowLoader(false);
            logger.error(e);
        }
    }
  
    return(
        <CForm onSubmit={handleSubmit(onSubmit)}>
            { showLoader ? <Loader /> : null }

            <CContainer className="mt-4 p-3" >
                <CRow>
                    <CCol md={4}>
                        <h5>{Language.SEND_BOOKING_NOTIFICATION}</h5>
                        <hr className="custom_hr"/>
                    </CCol>
                    <CCol md={8}></CCol>

                    <CCol md={12} className="map-image"> 
                        <div> 
                            <b className="radio_label"><CFormCheck {...register('sendNotificationByWhatsApp')} id="sendNotificationByWhatsApp" label={Language.SEND_WHATSAPP_NOTIFICATION}/> </b> 
                            <div className="">
                                <div className="phone_input_container">
                                    <div className="phone_country_code_container">
                                        <CFormSelect {...register("whatsappPhoneCountryCode")} id="whatsappPhoneCountryCode">
                                            {
                                                CountryCode.map(code => {
                                                    return(
                                                        <option value={code.code} key={code.code}>+ {code.code}</option>
                                                    )
                                                })
                                            }
                                        </CFormSelect>
                                    </div>
                                    <CFormInput {...register("whatsappPhoneNumber")}  type="number" id="whatsappPhoneNumber" placeholder={Language.PHONE_NUMBER} aria-describedby="whatsappPhoneNumber" />
                                </div> 
                                
                                { errors.whatsappPhoneNumber && <div className="alert alert-danger">{errors.whatsappPhoneNumber.message}</div> }
                            </div>
                        </div>
                    </CCol>

                    <CCol md={12} className="mt-4"> </CCol>
                    <hr></hr>
        
                    <CCol md={12} className="map-image"> 
                        <div> 
                            <b className="radio_label"><CFormCheck {...register("sendNotificationByEmail")} id="sendNotificationByEmail" label={Language.SEND_EMAIL_NOTIFICATION}/> </b> 
                            <div className="">
                                <div className="phone_input_container">
                                    <CFormInput  type="string" {...register("email")}  id="email" placeholder={Language.EMAIL} aria-describedby="email" />
                                </div> 
                                { errors.email && <div className="alert alert-danger">{errors.email.message}</div> }
                            </div>
                        </div>
                    </CCol>

                    <CCol md={12} className="mt-4"> </CCol>
                    <hr></hr>

                    <CCol md={12} className="map-image"> 
                        <div> 
                            <b className="radio_label"><CFormCheck  {...register("sendNotificationBySms")} id="sendNotificationBySms" label={Language.SEND_SMS_NOTIFICATION}/> </b> 
                            <div className="">
                                <div className="phone_input_container">
                                    <div className="phone_country_code_container">
                                        <CFormSelect {...register("smsPhoneCountryCode")} id="smsPhoneCountryCode">
                                            {
                                                CountryCode.map(code => {
                                                    return(
                                                        <option value={code.code} key={code.code}>+ {code.code}</option>
                                                    )
                                                })
                                            }
                                        </CFormSelect>
                                    </div>
                                    <CFormInput {...register("smsPhoneNumber")}  type="number" id="smsPhoneNumber" placeholder={Language.PHONE_NUMBER} aria-describedby="whatsappPhoneNumber" />
                                </div> 
                                { errors.smsPhoneNumber && <div className="alert alert-danger">{errors.smsPhoneNumber.message}</div> }
                            </div>
                        </div>
                    </CCol>

                    <CCol md={12} className="mt-4"> </CCol>
                    <hr></hr>
                    <CCol md={4} className=""> </CCol>
                    <CCol md={4} className=""> 
                        <CButton type="submit" className="submit_button">
                            {
                                Language.SAVE_BUSINESS_NOTIFICATION_DETAILS
                            }
                        </CButton>
                    </CCol>
                    <CCol md={4} className=""> 
                    </CCol>
                </CRow>
            </CContainer>
        </CForm>
    )
}
export default BusinessNotificationForm;